import styled from "@emotion/styled";

const StyledIcon = styled("span")({
  "& > svg": {
    verticalAlign: "sub",
  },
});

export { StyledIcon };
